import React from "react";
import "./ConfigPane.scss";
import "../../../generic/genericStyles.scss";
//import ConfigPaneFormRow from "./ConfigPaneFormRow";
import CopyableLabel from "../CopyableLabel";
import { withTranslation } from "react-i18next";
class DeviceComConfigPane extends React.Component {
  constructor(props) {
    super(props);
    this.state = { txt: "" };
  }

  componentDidMount() {}

  render() {
    let { device, t } = this.props;
    let { comConfig } = device;
    let { apiKey = "NOKEY" } = comConfig;
    return (
      <div className="configpane-inner">
        <div className="configpane-form">
          <div className="configpane-section">
            <div className="configpane-section-head">{t("apikey_label")}</div>
            <div className="configpane-section-content">
              <div className="configpane-form-row">
                <CopyableLabel text={`${apiKey}`} />
              </div>
              <br />

              <p className="descriptionText centered">{t("apikey_instr1")}</p>
            </div>
          </div>
          <div className="configpane-section">
            <div className="configpane-section-head">URL</div>
            <div className="configpane-section-content">
              <div className="descriptionText centered">
                {t("apikey_instr2")}
              </div>
              <CopyableLabel text={`http://palamoa.de/json/${apiKey}`} />
            </div>
          </div>
          <div className="configpane-section">
            <div className="configpane-section-head">{t("header_field_label")}</div>
            <div className="configpane-section-content">
              <p className="descriptionText centered">{t("apikey_instr3")}</p>
              <pre className="genericTextBox">
                ...
                <br />
                Apikey: {apiKey}<br />
                ...
              </pre>
            </div>
          </div>
          <div className="configpane-section">
            <div className="configpane-section-head">JSON</div>
            <div className="configpane-section-content">
              <p className="descriptionText centered">{t("apikey_instr4")}</p>
              <pre className="genericTextBox">
                "apikey": "{apiKey}",
                <br />
                ...{t("sensor_data_label")}:"...",
                <br />
                ...
              </pre>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DeviceComConfigPane);
